import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import Examination_navbar from "./Examination_navbar";
import SessionsDropDown from "../Shared/SessionsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";
import {
  formatPublishedMark,
  readPublishedResultField,
} from "./publishedResultMarks";

function PrintPublishedResultCard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [SessionID, setSessionID] = useState(
    parseInt(localStorage.getItem("DefaultSession"), 10) || 0
  );
  const [resultCards, setResultCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);
  const [ResultCardID, setResultCardID] = useState(
    parseInt(searchParams.get("ID"), 10) || 0
  );
  const [WingID, setWingID] = useState(0);
  const [ClassID, setClassID] = useState(
    parseInt(searchParams.get("Class_Id"), 10) || 0
  );
  const [SectionID, setSectionID] = useState(
    parseInt(searchParams.get("Section_Id"), 10) || 0
  );
  const [resultCard, setResultCard] = useState(null);
  const [records, setRecords] = useState([]);

  useEffect(() => {
    document.title = "Print Published Result Card";
  }, []);

  useEffect(() => {
    if (!SessionID) {
      setResultCards([]);
      return;
    }

    setLoadingCards(true);
    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetResultCards",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, SessionID },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setResultCards(response.data.ListofRecords || []);
        } else {
          setResultCards([]);
        }
        setLoadingCards(false);
      })
      .catch(() => {
        setResultCards([]);
        setLoadingCards(false);
      });
  }, [SessionID]);

  const loadPublishedResults = (cardId, classId, sectionId) => {
    if (!cardId) {
      toast.error("Select a result card.");
      return;
    }

    setLoadingResults(true);
    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetPublishedResultCard",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: cardId,
        Class_Id: classId || 0,
        Section_Id: sectionId || 0,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setResultCard(response.data.ResultCard || null);
          setRecords(response.data.ListofRecords || []);
        } else {
          setResultCard(null);
          setRecords([]);
          toast.error(response.data.status_message || "No published results.");
        }
        setLoadingResults(false);
      })
      .catch(() => {
        setLoadingResults(false);
        toast.error("Network error.");
      });
  };

  useEffect(() => {
    if (ResultCardID > 0) {
      loadPublishedResults(ResultCardID, ClassID, SectionID);
    }
  }, []);

  const handleLoad = (event) => {
    event.preventDefault();
    setSearchParams({
      ID: ResultCardID || "",
      Class_Id: ClassID || "",
      Section_Id: SectionID || "",
    });
    loadPublishedResults(ResultCardID, ClassID, SectionID);
  };

  const printListUrl =
    ResultCardID > 0
      ? `/ExaminationSystem/PrintPublishedResultCardList?ID=${ResultCardID}&Class_Id=${ClassID || 0}&Section_Id=${SectionID || 0}`
      : "";

  const formatNumber = formatPublishedMark;

  return (
    <>
      <Examination_navbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/ExaminationSystem/ExaminationDashboard">
                      Examinations
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Print Published Results
                  </li>
                </ol>
              </nav>
              <div className="page-title">Print Published Result Card</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions d-flex gap-2 justify-content-md-end">
                <Link
                  to={printListUrl || "#"}
                  className={`button button-white button-icon ${
                    !printListUrl || records.length === 0 ? "disabled" : ""
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    if (!printListUrl || records.length === 0) {
                      e.preventDefault();
                      toast.error("Load published results before printing the list.");
                    }
                  }}
                >
                  Print List
                  <i className="ri-printer-line"></i>
                </Link>
                <Link
                  to={
                    ResultCardID > 0 && ClassID > 0 && SectionID > 0
                      ? `/ExaminationSystem/PrintPublishedStudentResultCards?ID=${ResultCardID}&ClassId=${ClassID}&SectionId=${SectionID}`
                      : "#"
                  }
                  className={`button button-white button-icon ${
                    !ResultCardID || !ClassID || !SectionID ? "disabled" : ""
                  }`}
                  onClick={(e) => {
                    if (!ResultCardID || !ClassID || !SectionID) {
                      e.preventDefault();
                      toast.error("Select result card, class, and section for student cards.");
                    } else {
                      scrollToTop();
                    }
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Student Cards
                  <i className="ri-file-user-line"></i>
                </Link>
                <Link
                  to="/ExaminationSystem/PublishResultCard"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Publish Results
                  <i className="ri-upload-cloud-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card mb-3 no-print">
            <div className="card-body">
              <Form onSubmit={handleLoad}>
                <div className="row">
                  <div className="col-md-3">
                    <label>Session</label>
                    <select
                      className="form-select"
                      value={SessionID}
                      onChange={(e) => {
                        setSessionID(parseInt(e.target.value, 10) || 0);
                        setResultCardID(0);
                      }}
                    >
                      <option value="">Please Select</option>
                      <SessionsDropDown />
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Result Card</label>
                    <select
                      className="form-select"
                      required
                      value={ResultCardID}
                      onChange={(e) =>
                        setResultCardID(parseInt(e.target.value, 10) || 0)
                      }
                    >
                      <option value="">Please Select</option>
                      {loadingCards ? (
                        <option disabled>Loading...</option>
                      ) : (
                        resultCards.map((item) => (
                          <option key={item.ID} value={item.ID}>
                            {item.ResultCard_Code} - {item.Title}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Wing</label>
                    <select
                      className="form-select"
                      value={WingID}
                      onChange={(e) => {
                        setWingID(e.target.value);
                        setClassID(0);
                        setSectionID(0);
                      }}
                    >
                      <option value="0">All</option>
                      <WingsDropDown selectedWingId={WingID} />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Class</label>
                    <select
                      className="form-select"
                      value={ClassID}
                      onChange={(e) => {
                        setClassID(e.target.value);
                        setSectionID(0);
                      }}
                    >
                      <option value="0">All</option>
                      <ClassesDropDown
                        WingID={WingID}
                        SessionID={SessionID}
                        selectedClassId={ClassID}
                      />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Section</label>
                    <select
                      className="form-select"
                      value={SectionID}
                      onChange={(e) => setSectionID(e.target.value)}
                    >
                      <option value="0">All</option>
                      <SectionDropDown
                        ClassID={ClassID}
                        selectedSectionId={SectionID}
                      />
                    </select>
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    {loadingResults ? (
                      <Spinner animation="border" role="status" />
                    ) : (
                      <button type="submit" className="button button-primary w-100">
                        Load
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {resultCard && (
                <div className="text-center mb-4">
                  <h4 className="mb-1">
                    {resultCard.Print_Title || resultCard.Title}
                  </h4>
                  <p className="text-muted mb-0">
                    {resultCard.ResultCard_Code} &middot; {resultCard.Result_Type}{" "}
                    &middot; Version {resultCard.Publish_Version || 1}
                  </p>
                </div>
              )}

              {loadingResults ? (
                <div className="text-center py-4">
                  <Spinner animation="border" role="status" />
                </div>
              ) : records.length === 0 ? (
                <p className="text-muted mb-0">
                  No published results found for the selected filters.
                </p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm print-results-table">
                    <thead>
                      <tr>
                        <th>Pos.</th>
                        <th>Reg. No.</th>
                        <th>Student Name</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Total</th>
                        <th>Obtained</th>
                        <th>%</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((item) => (
                        <tr key={item.ID}>
                          <td>{item.Section_Position || "-"}</td>
                          <td>{item.Registration_No}</td>
                          <td>{item.Student_Name}</td>
                          <td>{item.Class_Name}</td>
                          <td>{item.Section_Name}</td>
                          <td>{formatNumber(readPublishedResultField(item, "Total_Marks"))}</td>
                          <td>{formatNumber(readPublishedResultField(item, "Obtained_Marks"))}</td>
                          <td>{formatNumber(readPublishedResultField(item, "Percent_Marks"))}</td>
                          <td>{readPublishedResultField(item, "Grade") || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrintPublishedResultCard;
